module.exports = __webpack_public_path__ + "static/media/imagingResultsIconColor.acf34bbf.png";